import MaintenanceLocation from './MaintenanceLocation.vue'
export default MaintenanceLocation


// WEBPACK FOOTER //
// ./src/pages/MaintenanceLocation/index.js